const PredefinedTemplates = [
	{
		name: 'vitality',
		tint: 'soho',
		form: {
			title: [
				{ languageID: 'nl_NL', text: 'Vitaliteitsgesprek' },
				{ languageID: 'en_US', text: 'Vitality conversation' },
			],
			description: [
				{
					languageID: 'nl_NL',
					text: {
						ops: [
							{
								insert:
									'Wij geloven dat energieke en vitale mensen gelukkiger zijn en het beste uit zichzelf halen. Vitaliteit is levenskracht. Vul dit formulier in om te bespreken hoe het staat met jouw vitaliteit en waar jij en wij als organisatie nog kunnen verbeteren als het gaat om jou ondersteunen in een optimale gezondheid, balans en werk- en energiebeleving. Reageer eerst op de gegeven stellingen en beantwoord vervolgens de vragen over de toekomstige situatie.\n',
							},
						],
					},
				},
				{
					languageID: 'en_US',
					text: {
						ops: [
							{
								insert:
									'The goal of this form is to evaluate the status of your vitality, where you want to improve and where we, as an organisation, could improve. By talking about it, we achieve to help you reach the optimal health, balance, work- and energy experience. Fill in the questions about the current situation first, then you can answer the questions about the future situation.\n',
							},
						],
					},
				},
			],
			sections: [
				{
					items: [
						{
							type: 'TITLE',
							fillInBy: 'BOTH',
							title: {
								text: [
									{ languageID: 'nl_NL', text: 'Vitaliteitsgesprek' },
									{ languageID: 'en_US', text: 'Vitality conversation' },
								],
							},
						},
						{
							type: 'SENTIMENT',
							fillInBy: 'EMPLOYEE',
							sentiment: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Mijn werk en privé zijn in balans',
									},
									{
										languageID: 'en_US',
										text: 'My work and private life is balanced',
									},
								],
								displayMethod: 'EMOJI',
							},
						},
						{
							type: 'SENTIMENT',
							fillInBy: 'EMPLOYEE',
							sentiment: {
								title: [
									{ languageID: 'nl_NL', text: 'Ik voel me energiek' },
									{ languageID: 'en_US', text: 'I feel energetic' },
								],
								displayMethod: 'EMOJI',
							},
						},
						{
							type: 'SENTIMENT',
							fillInBy: 'EMPLOYEE',
							sentiment: {
								title: [
									{ languageID: 'nl_NL', text: 'Ik voel me gezond' },
									{ languageID: 'en_US', text: 'I feel healthy' },
								],
								displayMethod: 'EMOJI',
							},
						},
						{
							type: 'SENTIMENT',
							fillInBy: 'EMPLOYEE',
							sentiment: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Ik ben gemotiveerd in mijn werk',
									},
									{ languageID: 'en_US', text: 'I am motivated at work' },
								],
								displayMethod: 'EMOJI',
							},
						},
						{
							type: 'SENTIMENT',
							fillInBy: 'EMPLOYEE',
							sentiment: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Ik voel me veilig en op mijn gemak',
									},
									{ languageID: 'en_US', text: 'I feel save and at ease' },
								],
								displayMethod: 'EMOJI',
							},
						},
						{
							type: 'SENTIMENT',
							fillInBy: 'EMPLOYEE',
							sentiment: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Ik ben betrokken bij de organisatie',
									},
									{
										languageID: 'en_US',
										text: 'I feel involved with the organisation',
									},
								],
								displayMethod: 'EMOJI',
							},
						},
						{
							type: 'SENTIMENT',
							fillInBy: 'EMPLOYEE',
							sentiment: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Ik voel me onderdeel van het team',
									},
									{ languageID: 'en_US', text: 'I feel part of the team' },
								],
								displayMethod: 'EMOJI',
							},
						},
						{
							type: 'SENTIMENT',
							fillInBy: 'EMPLOYEE',
							sentiment: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Ik kan zelfstandig mijn werk doen',
									},
									{ languageID: 'en_US', text: 'I can work independently' },
								],
								displayMethod: 'EMOJI',
							},
						},
					],
				},
				{
					items: [
						{
							type: 'TITLE',
							fillInBy: 'BOTH',
							title: {
								text: [
									{ languageID: 'nl_NL', text: 'Vertel eens meer...' },
									{ languageID: 'en_US', text: 'Tell us some more...' },
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Ik verwacht de aankomende tijd veranderingen in mijn werk privé balans want...',
									},
									{
										languageID: 'en_US',
										text: 'I expect changes in my work/life balance because of...',
									},
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Ik probeer gezond en energiek te blijven door...',
									},
									{
										languageID: 'en_US',
										text: 'I try to stay healthy and energetic by...',
									},
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Ik wil mij nog verder ontwikkelen op het gebied van...',
									},
									{
										languageID: 'en_US',
										text: 'I want to learn more in the area of...',
									},
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Ik zie de volgende uitdagingen in mijn werk...',
									},
									{
										languageID: 'en_US',
										text: 'I foresee the following challenges at work...',
									},
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Mijn werk wordt (nog) leuker als...',
									},
									{
										languageID: 'en_US',
										text: 'My work will be (even) more fun when...',
									},
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Om mijn werk de komende periode uit te kunnen voeren is het nodig dat...',
									},
									{
										languageID: 'en_US',
										text: 'To do my work the coming period, it is necessary that...',
									},
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Mijn team kan van mij verwachten....',
									},
									{
										languageID: 'en_US',
										text: 'My team can expect from me that...',
									},
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: "Ik verwacht van mijn collega's...",
									},
									{
										languageID: 'en_US',
										text: 'I expect from my colleagues that...',
									},
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Om mijn inzetbaarheid te verhogen is het nodig dat...',
									},
									{
										languageID: 'en_US',
										text: 'To increase my employability it is necessary that',
									},
								],
							},
						},
					],
				},
			],
		},
	},
	{
		name: 'development',
		tint: 'tropical',
		form: {
			title: [
				{ languageID: 'nl_NL', text: 'Ontwikkelgesprek' },
				{ languageID: 'en_US', text: 'Growth talk' },
			],
			description: [
				{
					languageID: 'nl_NL',
					text: {
						ops: [
							{
								insert:
									'Het ontwikkelgesprek stimuleert je om na te denken over je prestaties en ontwikkeling en je bewust te maken van je wensen op het gebied van professionele ontwikkeling. Hierin kijk je terug op de afgelopen periode maar kijk je ook vooruit naar de toekomst. Daarbij bespreken we de match tussen jou en de organisatie.\n',
							},
						],
					},
				},
				{
					languageID: 'en_US',
					text: {
						ops: [
							{
								insert:
									'The growth talk stimulates you to think about your performance and development and increases your awareness of your wishes in the area of professional growth. We are going to look back on the previous period but also look forward to the future. We talk here about the match between you and your organisation.\n',
							},
						],
					},
				},
			],
			sections: [
				{
					items: [
						{
							type: 'TITLE',
							fillInBy: 'BOTH',
							title: {
								text: [
									{ languageID: 'nl_NL', text: 'Terugblikken' },
									{ languageID: 'en_US', text: 'Looking back' },
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Waar ben je trots op, kreeg je energie van of werd je blij van?',
									},
									{
										languageID: 'en_US',
										text: 'What are you proud of, gave you energy or made you happy?',
									},
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Welke talenten heb jij die je graag nog vaker in zou willen zetten?',
									},
									{
										languageID: 'en_US',
										text: 'Which talents do you possess and would  you like to use more?',
									},
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Wat wil je graag meer prioriteit geven de komende maanden en waarom?',
									},
									{
										languageID: 'en_US',
										text: 'What would you like to prioritise the upcoming months and why?',
									},
								],
							},
						},
					],
				},
				{
					items: [
						{
							type: 'TITLE',
							fillInBy: 'BOTH',
							title: {
								text: [
									{ languageID: 'nl_NL', text: 'Doelen en ontwikkeling' },
									{ languageID: 'en_US', text: 'Goals and growth' },
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Zijn er specifieke doelen die je voor ogen hebt of die je wil bereiken in jouw persoonlijke ontwikkeling?',
									},
									{
										languageID: 'en_US',
										text: 'Are there specific goals you had in mind or that you would like to reach with regards to your personal growth?',
									},
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Welke acties ga je ondernemen naar aanleiding van je doelen?',
									},
									{
										languageID: 'en_US',
										text: 'What actions are you going to take with regards to your goals?',
									},
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Hoe ga je de komende periode je kennis en expertise verder ontwikkelen? Wat zijn de obstakels of factoren die je hierin kunnen belemmeren?',
									},
									{
										languageID: 'en_US',
										text: 'How are you going to develop your knowledge and expertise during the upcoming months. What are obstacles or factors that could obstruct this?',
									},
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Wat wil je de komende periode verder ontwikkelen op persoonlijk vlak? Denk aan competenties, soft skills, werk-privé balans. Hoe kan de organisatie je daarbij helpen?',
									},
									{
										languageID: 'en_US',
										text: 'What would you like to develop on a personal level the coming period? Think about competencies, soft-skills and work/private life balance. How can the organisation help you with this?',
									},
								],
							},
						},
					],
				},
				{
					items: [
						{
							type: 'TITLE',
							fillInBy: 'BOTH',
							title: {
								text: [
									{
										languageID: 'nl_NL',
										text: 'Betrokkenheid bij de organisatie',
									},
									{
										languageID: 'en_US',
										text: 'Involvement with the organisation',
									},
								],
							},
						},
						{
							type: 'SENTIMENT',
							fillInBy: 'EMPLOYEE',
							sentiment: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Voel je je op je plek binnen de organisatie?',
									},
									{
										languageID: 'en_US',
										text: 'Do you feel at home at the organisation?',
									},
								],
								displayMethod: 'EMOJI',
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{ languageID: 'nl_NL', text: 'Waar komt dit door?' },
									{
										languageID: 'en_US',
										text: 'What makes you feel like this?',
									},
								],
							},
						},
						{
							type: 'SENTIMENT',
							fillInBy: 'EMPLOYEE',
							sentiment: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Voel je je gewaardeerd door de organisatie?',
									},
									{
										languageID: 'en_US',
										text: 'Do you feel appreciated by the organisation?',
									},
								],
								displayMethod: 'EMOJI',
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{ languageID: 'nl_NL', text: 'Hoe komt dit?' },
									{
										languageID: 'en_US',
										text: 'What makes you feel like this?',
									},
								],
							},
						},
						{
							type: 'SENTIMENT',
							fillInBy: 'EMPLOYEE',
							sentiment: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Hoe ervaar je de balans in de hoeveelheid werk?',
									},
									{
										languageID: 'en_US',
										text: 'How do you experience the balance with regards to the amount of work?',
									},
								],
								displayMethod: 'EMOJI',
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: "Wat kan je doen om dit te verbeteren? Waar kunnen je collega's je bij helpen?",
									},
									{
										languageID: 'en_US',
										text: 'What can you do to make this better? What can  your colleagues do?',
									},
								],
							},
						},
					],
				},
				{
					items: [
						{
							type: 'TITLE',
							fillInBy: 'BOTH',
							title: {
								text: [
									{ languageID: 'nl_NL', text: 'Vooruitkijken' },
									{ languageID: 'en_US', text: 'Looking ahead' },
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Hoe zou jij je grenzen verder willen verleggen? Denk hierbij bijvoorbeeld aan je functie, verantwoordelijkheden, competenties of nieuwe projecten.',
									},
									{
										languageID: 'en_US',
										text: 'How could you push your boundaries even more? Think about your function, responsibilities, competencies or new projects.',
									},
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Hoe kan je hier een start mee maken? Wat zijn de vervolgstappen die je gaat zetten?',
									},
									{
										languageID: 'en_US',
										text: 'How would you start? What are the next steps you are going to take?',
									},
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'EMPLOYEE',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Hoe kan de organisatie je hierbij helpen?',
									},
									{
										languageID: 'en_US',
										text: 'How can the organisation help you with this?',
									},
								],
							},
						},
					],
				},
			],
		},
	},
	{
		name: 'intermediate',
		tint: 'sun',
		form: {
			title: [
				{ languageID: 'nl_NL', text: 'Tussentijds inchecken' },
				{ languageID: 'en_US', text: 'Intermediate check-ins' },
			],
			description: [
				{
					languageID: 'nl_NL',
					text: {
						ops: [
							{
								insert:
									'Met dit format kun je tussentijds de voortgang bespreken van jouw groei en gestelde doelen. Bespreek wat nodig is: wat zit je dwars? Waar heb je hulp nodig? Wat gaat goed?\n',
							},
						],
					},
				},
				{
					languageID: 'en_US',
					text: {
						ops: [
							{
								insert:
									'With this form you can intermediately talk about you progress of your goals and growth. It is important to talk about what you feel is  necessary: What is bothering you? What do you need help with? What is going well?\n',
							},
						],
					},
				},
			],
			sections: [
				{
					items: [
						{
							type: 'TITLE',
							fillInBy: 'BOTH',
							title: {
								text: [
									{ languageID: 'nl_NL', text: 'Tussentijds inchecken' },
									{ languageID: 'en_US', text: 'Checking-in intermediately' },
								],
							},
						},
						{
							type: 'SENTIMENT',
							fillInBy: 'EMPLOYEE',
							sentiment: {
								title: [
									{ languageID: 'nl_NL', text: 'Hoe gaat het met je?' },
									{ languageID: 'en_US', text: 'How are you doing?' },
								],
								displayMethod: 'EMOJI',
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'BOTH',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Waar moeten we het over hebben vandaag?',
									},
									{
										languageID: 'en_US',
										text: 'What should we talk about today?',
									},
								],
							},
						},
						{
							type: 'OPEN_QUESTION',
							fillInBy: 'BOTH',
							openQuestion: {
								title: [
									{
										languageID: 'nl_NL',
										text: 'Wat is de status van jouw doelen? Wat heb je nodig om hiermee verder te gaan?',
									},
									{
										languageID: 'en_US',
										text: 'What is the status of your goals? What do you need to achieve these?',
									},
								],
							},
						},
					],
				},
			],
		},
	},
];

export default PredefinedTemplates;
